require('./bootstrap');

import Collapse from 'bootstrap/js/dist/collapse';
import Tab from 'bootstrap/js/dist/Tab';

import 'slick-carousel'

require('busy-load');

require('./general');

require('./payment');